export const cardTypeOptions = [
    { label: "cash sale total revenue without vat", value: "cash_sale_total_revenue_without_vat" },
    { label: "cash sale total payment with vat", value: "cash_sale_total_payment_with_vat" },
    // { label: "cash sale department total revenue without vat", value: "cash_sale_department_total_revenue_without_vat" },
    { label: "cash sale total discount", value: "cash_sale_total_discount" },
    { label: "cash sale total vat", value: "cash_sale_total_vat" },
    { label: "cash sale total payment cost", value: "cash_sale_total_payment_cost" },

    { label: "cash credit total revenue without vat", value: "cash_credit_total_revenue_without_vat" },
    { label: "cash credit total payment with vat", value: "cash_credit_total_payment_with_vat" },
    { label: "cash credit department total revenue without vat", value: "cash_credit_department_total_revenue_without_vat" },
    { label: "cash credit total discount", value: "cash_credit_total_discount" },
    { label: "cash credit total vat", value: "cash_credit_total_vat" },
    { label: "cash credit total payment cost", value: "cash_credit_total_payment_cost" },

    { label: "insurance total revenue without vat", value: "insurance_total_revenue_without_vat" },
    { label: "insurance total vat", value: "insurance_total_vat" },
    //  { label: "insurance department total revenue without vat", value: "insurance_department_total_revenue_without_vat" },

    { label: "coperate total revenue without vat", value: "coperate_total_revenue_without_vat" },
    { label: "coperate total vat", value: "coperate_total_vat" },
    // { label: "coperate department total revenue without vat", value: "coperate_department_total_revenue_without_vat" },

    { label: "government total revenue without vat", value: "government_total_revenue_without_vat" },
    { label: "government total vat", value: "government_total_vat" },
    { label: "government department total revenue without vat", value: "government_department_total_revenue_without_vat" },

    { label: "advance deposit total revenue without vat", value: "advance_deposit_total_revenue_without_vat" },
    { label: "advance deposit total payment with vat", value: "advance_deposit_total_payment_with_vat" },
    { label: "advance deposit department total revenue without vat", value: "advance_deposit_department_total_revenue_without_vat" },
    { label: "advance deposit total payment cost", value: "advance_deposit_total_payment_cost" },

    { label: "deposit use total revenue without vat", value: "deposit_use_total_revenue_without_vat" },
    { label: "deposit use total payment with vat", value: "deposit_use_total_payment_with_vat" },
    //    { label: "deposit use department total revenue without vat", value: "deposit_use_department_total_revenue_without_vat" },
    { label: "deposit use total discount", value: "deposit_use_total_discount" },

    { label: 'Bupa Arabia for Cooperative Insurance', value: '7001571327' },
    { label: 'Global Company for Cooperative Insurance', value: '7001609481' },
    { label: 'Malath Cooperative Insurance and Reinsurance Company', value: '7001519912' },
    { label: 'The Cooperative Company for Cooperative Insurance (Tawuniya)', value: '7000911508' },
    { label: 'Gulf Insurance Group (GIG)', value: '7001607683' },
    { label: 'Saudi Arabian Cooperative Insurance Company (SAICO)', value: '7001539720' },
    { label: 'The Mediterranean and Gulf Cooperative Insurance and Reinsurance Company (MedGulf)', value: '7001548317' },
    { label: 'The National Company for Cooperative Insurance', value: '7001534275' },
    { label: 'Gulf Union Cooperative Insurance Company', value: '7001532279' },
    { label: 'Self Paid', value: '0000000' },
    { label: 'Trade Union Cooperative Insurance Company', value: '7001549059' },
    { label: 'Alrajhi Takaful for Cooperative Insurance', value: '7001593321' }
    ,
    { label: 'Saudi United Cooperative Insurance Company (Wala)', value: '7001526578' },
    { label: 'Al Jazira Takaful Company', value: '7001625891' },
    { label: 'Amana Cooperative Insurance Company', value: '7001626717' },
    { label: 'Arabia Insurance Cooperative Company', value: '7001527667' },
    { label: 'Mutakamela Insurance Company', value: '7001537161' },
    { label: 'Salama Cooperative Insurance Company', value: '7001523724' },
    { label: 'Center for National health insurance', value: '0000000163' },
    { label: 'Saudi Enaya Cooperative Insurance Company', value: '7001703672' },
    { label: 'Orient Insurance', value: '7041839510' }
    ,
    { label: 'Mutakamela Insurance Company', value: '7001537161_nc' },
    { label: 'Al Sagr Cooperative Insurance Company', value: '7001544472_nc' },
    { label: 'Al Jazira Takaful Company', value: '7001625891_nc' },
    { label: 'Saudi United Cooperative Insurance Company (Wala)', value: '7001526578_nc' }
    ,
    { label: 'Gulf General Company for Cooperative Insurance', value: '7001641419_mn' },
    { label: 'Saudi United Cooperative Insurance Company (Wala)', value: '7001526578_mn' }
    ,
    { label: 'Arabian Shield Cooperative Insurance Company', value: '7001527816' },
    { label: 'Cigna Worldwide Insurance Company Branch', value: '7030409622' },
    { label: 'Trade Union Cooperative Insurance Company', value: '7001549059_tc' },
    { label: 'United Cooperative Insurance Company (UCA)', value: '7001559389' },
    { label: 'Tokyo Marine Development Corporation', value: '7001727200' },
    { label: 'The Cooperative Company for Cooperative Insurance (Tawuniya)', value: '7000911508_tc' },
    { label: 'Buruj Cooperative Insurance Company', value: '7001617724' },
    { label: 'Gulf General Company for Cooperative Insurance', value: '7001641419_tc' },
    { label: 'Allied Cooperative Insurance Group (ACIG)', value: '7001535694' },
    { label: 'Al Sagr Cooperative Insurance Company', value: '7001544472_tc' },
    { label: 'MSF', value: '111111' },
    { label: 'Medical Treatment	', value: '7638898298' }
]

export const getLabelFromValue = (value) => {
    if (!value) return ''
    const item = cardTypeOptions?.find(i => i.value === value)
    if (item) return item?.label
    return value
}


export const paymentOptions = [
    { label: "Cash Sale", value: "cash_sale" },
    { label: "Cash Credit", value: "cash_credit" },
    { label: "Insurance", value: "insurance" },
    { label: "Corporate", value: "corporate" },
    { label: "Government", value: "government" },
    { label: "Advance Deposit", value: "advance_deposit" },
    { label: "Advance Deposit Use", value: "advance_deposit_use" },
    // { label: "Withdraw Advance Payments", value: "withdraw_advance" },
    { label: "Withdraw Advance Payments", value: "withdraw_advance" },
    { label: "Medicine Cost", value: "medicine_cost" }
];
